import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';
import LeaveTypeList from './pages/private/LeaveTypeList';
import {partTimeJobIds, GetStoreRole} from '../const/constant';
import API from '../middleware/API';

class FillLeave extends Component {
  constructor(props) {
    super(props);
    this.state={
      leaveType: 0,
      selectDate: moment(),
      selectStartTime: moment(),
      selectEndTime: moment(),
      reason:'',
      attach:'',
      notes:'',
      name:'',
      byManual: true,
      beforeDay:0,
      minHours:0,
      wageTimes:0,
      leavesDay:0,
      deLeaveAmt:0,
      remainHolidayHours:0,
      staff:0,
      currentRole: GetStoreRole(localStorage.getItem('current_store_id'))
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handleLeaveTypeChange = this.handleLeaveTypeChange.bind(this);
    this.handleStaffTypeChange = this.handleStaffTypeChange.bind(this);
    this.handleSelectDateChange = this.handleSelectDateChange.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.fileInput = React.createRef();
    this.emptyAllField = this.emptyAllField.bind(this);
    this.updateRemainHolidayHour = this.updateRemainHolidayHour.bind(this);
  }
  handleSelectStartTimeChange(moment) {    
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {    
    this.setState({
      selectEndTime: moment
    })
  }

  handleLeaveTypeChange(e) {  
    let leaveType = this.props.allLeaveType.find(leaveType => leaveType.id === parseInt(e.target.value))
    if(leaveType.id === 24){
      API.get('/LeaveRec/RemainHolidayHour?input='+this.props.editTarget.sDate).then((res)=>{
        this.setState({
          leaveType: leaveType.id,
          notes: leaveType.notes,
          name: leaveType.name,
          beforeDay: leaveType.beforeDay,
          minHours: leaveType.minHours,
          wageTimes: leaveType.wageTimes,
          leavesDay: leaveType.leavesDay,
          deLeaveAmt: leaveType.deLeaveAmt,
          remainHolidayHours: res,
        })
      })
      
    }else{
      this.setState({
        leaveType: leaveType.id,
        notes: leaveType.notes,
        name: leaveType.name,
        beforeDay: leaveType.beforeDay,
        minHours: leaveType.minHours,
        wageTimes: leaveType.wageTimes,
        leavesDay: leaveType.leavesDay,
        deLeaveAmt: leaveType.deLeaveAmt,
      })
    }


  }

  handleStaffTypeChange(e) {
    this.setState({
        staff: e.target.value
    })
  }

  handleReasonChange(e) {
    this.setState({
      reason: e.target.value
  })
  }
  diff = (start, end) => {
    start = start.split(":");
    end = end.split(":");
    let startDate = new Date(0, 0, 0, start[0], start[1], 0);
    let endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();
    let hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    let minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    if (hours < 0)
       hours = hours + 24;

    // if (hours + (minutes/60) > 8 && this.state.leaveType === 1)
    //   swal({
    //     type: 'error',
    //     title: '特休一天最多只能請8小時',
    //     showConfirmButton: false,
    //     showCloseButton: true,
    //     heightAuto: false,
    //     width: '250px'
    //   });
    if(hours + (minutes/60) > 8){
      //this.props.onChangeFunc('leaveHours', 8);
      return 8;
    }
    if((hours + (minutes/60) )> 0)
      //this.props.onChangeFunc('leaveHours', (hours + (minutes/60)));
    return hours + (minutes/60);
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { toggleOpen, longLeave,editTarget } = this.props;
    const { selectDate, selectStartTime,  selectEndTime, staff, reason, leaveType,currentRole} = this.state;
    if (editTarget.leaveItemId === 0) {
      swal({
        type: 'error',
        title: '尚未選取假別',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    // } else if (moment(editTarget.eDate).diff(moment(editTarget.sDate)) / 1000 / 60 / 60 > 8 && editTarget.leaveItemId === 1) {
    //   swal({
    //     type: 'error',
    //     title: '特休一天最多只能請8小時',
    //     showConfirmButton: false,
    //     showCloseButton: true,
    //     heightAuto: false,
    //     width: '250px'
    //   });
    //   return;
    } else if (moment(editTarget.eDate).diff(moment(editTarget.sDate)) <= 0) {
      swal({
        type: 'error',
        title: '時間輸入有誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (currentRole !== '4' && editTarget.agentUserId === 0) {
      swal({
        type: 'error',
        title: '請選擇職務代理人',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    this.emptyAllField();
    this.props.saveWorkRecordFunc(this.fileInput.current.files[0]);
    toggleOpen();
  }

  updateRemainHolidayHour(){
    API.get('/LeaveRec/RemainHolidayHour?input='+this.props.editTarget.sDate).then((res)=>{
      this.setState({
        remainHolidayHours: res,
      });
    })
  }

  emptyAllField(){
    this.setState({
      leaveType: 0,
      selectDate: moment(),
      selectStartTime: moment(),
      selectEndTime: moment(),
      reason:'',
      attach:'',
      staff:0,
    })
  }
  
  handleSelectDateChange(moment) {
    this.setState({
      selectDate: moment
    })
  }

  handleDateChangeRaw = (e) => {
    e.preventDefault();
  }
  onValueChange(event) {
    var targerValue = (event.target.value === 'true');
    if(!targerValue){
      this.props.onChangeFunc('eDate', moment(this.props.editTarget.eDate).format('YYYY-MM-DDTHH:mm'));
    }
    this.setState({
      byManual: targerValue
    })
  }
  render() {
    let { isVisible, toggleOpen, targetDate, editTarget, onChangeFunc, targetEventId, longLeave, allLeaveType } = this.props;
    let{currentRole, name}  = this.state;
    var modifiedLeaveType = [];
    
    allLeaveType.forEach((item)=>{
      if(item.id === 24 && currentRole === '6'){

      }else{
        modifiedLeaveType.push(item);
      }
    });

    if (!isVisible) {
      return null;
    }

    let isDisable = false;
    if( editTarget.leaveItemId === 1 && this.props.remainHours- editTarget.leaveHours < 0 )
      isDisable = true;
    
    if( editTarget.leaveItemId === 24 && this.state.remainHolidayHours - editTarget.leaveHours< 0 )
      isDisable = true;
          
    if( editTarget.leaveItemId === 23 && this.props.compensatoryHours- editTarget.leaveHours < 0 )
      isDisable = true;

    console.log(editTarget.leaveItemId)

    return (
    <div className="p-staff-list">
        <div className="u-editblock fadeIn" onClick={toggleOpen}>
              <div className="form-block" style={{maxWidth:'80%'}} onClick={(e)=>{e.stopPropagation();}}>
    <div className="u-small-title">{longLeave?'請長假':'請假單'}</div>
                <form className="u-form">
                  <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>假別：</label>
                      <select value={Number(editTarget.leaveItemId)} className="u-form__select" 
                        onChange={(e)=>{this.handleLeaveTypeChange(e);onChangeFunc('leaveItemId', e);}}
                      >
                        <option value="0" disabled>請選擇</option>
                        {
                          modifiedLeaveType.filter(leaveType => leaveType.enable).map(leaveType => (
                            leaveType.id===23&&this.props.compensatoryHours===0?
                            ''
                            :
                            <option key={leaveType.id} value={leaveType.id}>{ leaveType.name }</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：</label>
                      <DatePicker
                        locale="zh-tw"
                        placeholderText="請選擇日期"
                        dateFormat="YYYY-MM-DD"
                        autoComplete="off"
                        className="u-form__input"
                        selected={moment(editTarget.sDate)}
                        onChange={(e) => {

                          onChangeFunc('setDate', e.format('YYYY-MM-DD'));
                          this.updateRemainHolidayHour();
                        }}
                        selectsStart
                        startDate={moment(editTarget.sDate)}
                        disabled={this.props.dateDisabled}
                      />
                    </div>
                  </div>

                    {/* <div className="row">
                    {
                        longLeave ?
                        <>
                        <div className="col-6 col-pad-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：</label>
                        <DatePicker
                          locale="zh-tw"
                          placeholderText="請選擇日期"
                          dateFormat="YYYY-MM-DD"
                          autoComplete="off"
                          className="u-form__input"
                          selected={this.state.selectStartTime}
                          onChange={this.handleSelectStartTimeChange}
                          selectsStart
                          startDate={this.state.selectStartTime}
                          endDate={this.state.selectEndTime}
                        />
                        <label className="u-form__label text-align-right">起</label>
                        </div>
                        <div className="col-6 col-pad-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>至</label>
                        <DatePicker
                          locale="zh-tw"
                          placeholderText="請選擇日期"
                          dateFormat="YYYY-MM-DD"
                          autoComplete="off"
                          className="u-form__input"
                          selected={this.state.selectEndTime}
                          onChange={this.handleSelectEndTimeChange}
                          selectsEnd
                          startDate={this.state.selectStartTime}
                          endDate={this.state.selectEndTime}
                          minDate={this.state.selectStartTime}
                        />
                        <label className="u-form__label text-align-right">止</label>
                        </div>
                        </>
                        :
                        <div className="col-6 col-pad-12">

                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：</label>
                        <DatePicker
                          locale="zh-tw"
                          placeholderText="請選擇日期"
                          dateFormat="YYYY-MM-DD"
                          autoComplete="off"
                          className="u-form__input"
                          selected={this.state.selectStartTime}
                          onChange={this.handleSelectStartTimeChange}
                          selectsStart
                          startDate={this.state.selectStartTime}
                          endDate={this.state.selectStartTime}
                          minDate={this.state.selectStartTime}
                        />
                        </div>
                      }
                    </div> */}
                     
                    
                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>事由：</label>
                      <input type="text" className="u-form__input" value={editTarget.reasons} onChange={(e)=>{onChangeFunc('reasons', e);}}/>
                    </div>
                  </div>
                  <div className="row">
                    {
                      currentRole !== '4'?
                        <div className="col-6 col-pad-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>代理：</label>
                        <select value={Number(editTarget.agentUserId)} className="u-form__select" 
                          onChange={e => onChangeFunc('agentUserId', e)}
                        >
                          <option value="0" disabled>請選擇</option>
                          {
                            this.props.allStaff.filter(m => m.realName !== localStorage.getItem('adminName')).map(staff => (
                              <option key={staff.id} value={staff.id}>{ staff.realName }</option>
                            ))
                          }
                        </select>
                      </div>
                      :
                      ''
                    }

                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>附件：</label>
                      <input type="file" accept="image/*" ref={this.fileInput}/>
                    </div>
                  </div>
                  <div className="row">
                  <div className="col-6 col-pad-12">
                  </div>

                    <div className="col-6 col-pad-12">
                      (上傳格式為jpg或png)
                    </div>
                  </div>
                  {
                    longLeave ? 
                      ''
                    :
                    <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時段：</label>
                      <DatePicker
                        id="addWork_date_picker_selectStartTime"
                        locale="zh-tw"
                        showTimeSelect
                        showTimeSelectOnly
                        dateFormat="LT"
                        timeCaption="Time"
                        timeFormat="HH:mm"
                        selected={moment(editTarget.sDate)}
                        onChange={e => onChangeFunc('sDate', e.format('YYYY-MM-DDTHH:mm'))}
                        className="u-form__input mobile-hide"
                        disabledKeyboardNavigation
                        disableNativeKeyboard
                        onChangeRaw={this.handleDateChangeRaw}
                      />
                      <button
                          className="btn datepickinput desktop--hide"
                          onClick={(e) => {
                            e.preventDefault();
                            document.getElementById('addWork_date_picker_selectStartTime').click();
                          }}
                      >
                        {moment(editTarget.sDate).format('HH:mm')}
                      </button>
                    </div>
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>至：</label>
                      <DatePicker
                        id="addWork_date_picker_selectEndTime"
                        locale="zh-tw"
                        showTimeSelect
                        showTimeSelectOnly
                        dateFormat="LT"
                        timeCaption="Time"
                        timeFormat="HH:mm"
                        selected={moment(editTarget.eDate)}
                        onChange={e => onChangeFunc('eDate', e.format('YYYY-MM-DDTHH:mm'))}
                        className="u-form__input mobile-hide"
                        disabledKeyboardNavigation
                        disableNativeKeyboard
                        onChangeRaw={this.handleDateChangeRaw}
                      />
                      <button
                          className="btn datepickinput desktop--hide"
                          onClick={(e) => {
                            e.preventDefault();
                            document.getElementById('addWork_date_picker_selectEndTime').click();
                          }}
                      >
                        {moment(editTarget.eDate).format('HH:mm')}
                      </button>
                    </div> 
                  </div>
                  }

                  <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時數：
                      <input
                        type="radio"
                        value="true"
                        checked={this.state.byManual}
                        onChange={this.onValueChange}
                      />                                
                      自行填寫<input type="number" style={{width:"80px"}} step="0.5"  className="u-form__input" value={this.state.byManual && editTarget.leaveHours ? editTarget.leaveHours:0} onChange={(e)=>{onChangeFunc('leaveHours', e);}}/>小時
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5 col-pad-12">
                      <label className="u-form__label text-align-right" style={{marginLeft: '40px'}}>
                      <input
                        type="radio"
                        value="false"
                        checked={!this.state.byManual}
                        onChange={this.onValueChange}
                      /> 
                        系統計算:{this.state.byManual ? 0 : editTarget.leaveHours}小時<br/>(一日至多請8小時)</label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <div className="u-btn-group right">
                        {/* disable if 補休時數 <= 0} */}
                        <button type="button" className={"btn btn-md " + (isDisable ? 'cancel' : 'save')} disabled={isDisable} onClick={this.handleSaveWorkTime}>送出假單</button>
                        <button type="button" className="btn btn-md cancel m-l-16" onClick={
                          (e) => {
                            e.preventDefault();
                            this.emptyAllField();
                            toggleOpen();
                          }
                        }>取消</button>
                      </div>
                    </div>
                  </div>
                  {
                    this.state.leaveType > 0 ?
                    <div className="row">
                      <div className="col-6 col-pad-12">
                        <label className="u-form__label text-align-left" style={{flex: '0 0 54px'}}>
                          {
                            editTarget.leaveItemId === 1 ?
                            <span>您剩餘的特休時數:<span style={{color:'red'}}>{this.props.remainHours}<br/></span></span>:
                            editTarget.leaveItemId === 23 ?
                            <span>您剩餘的補休時數:<span style={{color:'red'}}>{this.props.compensatoryHours}<br/></span></span>:
                            editTarget.leaveItemId === 24 ?
                            <span>您剩餘的國定補休時數:<span style={{color:'red'}}>{this.state.remainHolidayHours}<br/></span></span>
                            :''
                          }
                        依規定請{this.state.beforeDay >= 0?'提前'+this.state.beforeDay:'事後'+ Math.abs(this.state.beforeDay)}天請{this.state.name}<br/>
                          最少請{this.state.minHours}小時，
                          扣{this.state.wageTimes}日薪<br/>
                          最多給假{this.state.leavesDay}天，
                          全勤加給扣{this.state.deLeaveAmt}元<br/>
                          </label>
                      </div>
                      <div className="col-6 col-pad-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>備註： </label>
                        <textarea name="notes" id="notes" cols="30" rows="3" disabled style={{resize:'none', border:'none', color:'black', background:'white'}} value={this.state.notes||''}></textarea>
                      </div>
                    </div>
                    :
                    ''
                  }

                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <img style={{maxWidth:'100%'}} src={editTarget.fileName}/>
                    </div>
                  </div>
                </form>
              </div>
            </div>
      </div>
    )
  }
}

export default FillLeave;